<section *ngIf="loading">
  <h2>Loading...</h2>
  <mat-progress-bar mode="indeterminate" color="primary" aria-label="Loading...">
  </mat-progress-bar>
</section>

<div *ngIf="!loading" fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
  <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
    <h2 class="noMarginHeader">
      <mat-icon>add</mat-icon> Add Scheduled Retest to {{retestType}}: {{identifier}}
    </h2>
  </div>
  <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="end">
    <button type="submit" (click)="onSubmit()" mat-raised-button color="primary" title="Update" [disabled]="authService.isReadOnly()">Add</button>
    &nbsp;&nbsp;
    <button mat-button mat-dialog-close="Cancel" aria-label="Cancel" mat-raised-button color="basic"
      title="Close">Close</button>
  </div>
</div>
<mat-dialog-content>
  <div *ngIf="!loading">
    <form #form="ngForm" [formGroup]="retestForm" class="form-field-full">
    <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">

      <div fxFlex="100.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
        <span>Retest will be associated with the highest Nitrate sample: 
            <span *ngIf="highestNitrateSample != undefined && highestNitrateSample != null">
              <b>Sample ID:</b> <span *ngIf="highestNitrateSample.sampleId > 0">
                &nbsp;&nbsp;<a href="javascript:void(0)" (click)="editSample(highestNitrateSample.sampleId)" title="View Sample Id {{highestNitrateSample.sampleId}}">{{highestNitrateSample.sampleId}}</a>
            </span>
            <span>
              &nbsp;&nbsp;<b>Sample Date:</b> {{highestNitrateSample.createDate}} &nbsp;&nbsp;<b>Nitrate Result: </b>{{nitrateResult}}
            </span>  
          </span>
        </span>
      </div>
    </div>
    <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
      <br />
      </div>
    <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
      <div fxFlex="33.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
        <mat-form-field appearance="standard">
          <mat-label>Retest Year (Recommend: {{recommendYear}})</mat-label>
          <mat-select id="retestYear" name="retestYear" formControlName="retestYear">
            <mat-option value=""></mat-option>
            <mat-option *ngFor="let item of retestService.retestYears" value="{{item.id}}">{{item.id}}</mat-option>
          </mat-select>
        </mat-form-field>
        <br />
      </div>
      
      <div fxFlex="33.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
        <mat-form-field appearance="standard">
          <mat-label>Retest Quarter (Recommend: Q{{recommendQuarter}})</mat-label>
          <mat-select id="retestQuarter" name="retestQuarter" formControlName="retestQuarter">
            <mat-option value=""></mat-option>
            <mat-option *ngFor="let item of retestService.retestQuarters" value="{{item.id}}">
              Quarter {{item.id}} (Q{{item.id}})
            </mat-option>
          </mat-select>
        </mat-form-field>
     </div>
     
       <div fxFlex="33.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
        <mat-form-field appearance="standard">
          <mat-label>Tier (Recommend: Tier {{recommendTier}})</mat-label>
          <mat-select id="tier" name="tier" formControlName="tier">
            <mat-option value=""></mat-option>
            <mat-option *ngFor="let item of retestService.tiers" value="{{item.id}}">Tier
              {{item.id}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    
    <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
      
      <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
        <mat-form-field appearance="standard">
          <mat-label>Due Date</mat-label>
          <input id="dueBy" name="dueBy" formControlName="dueBy" placeholder="mm/dd/yyyy" matInput
            [matDatepicker]="datepickerDueBy" />
          <mat-datepicker-toggle matSuffix [for]="datepickerDueBy"></mat-datepicker-toggle>
          <mat-datepicker #datepickerDueBy>
            <mat-datepicker-actions>
              <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
              <button mat-button matDatepickerCancel>Cancel</button>
            </mat-datepicker-actions>
          </mat-datepicker>
        </mat-form-field>
      </div>
    </div>

    <div fxLayout="row wrap" class="matero-row" fxLayoutGap="8px grid">
      <div fxFlex="100" fxFlex.lt-sm="100">
        <mat-form-field>
          <textarea matInput placeholder="Comments" formControlName="comments"></textarea>
        </mat-form-field>
      </div>
    </div>

  </form>
  </div>
  
</mat-dialog-content>